import { templates, getNameDocINE } from './'

export const coreFunctions = {};

coreFunctions.getActualDateTime = () => {
  //Obtener y dar formato a fecha y hora actuales
  let today = new Date();
  let day = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
  let month =
    today.getMonth() + 1 < 10
      ? "0" + (today.getMonth() + 1)
      : today.getMonth() + 1;
  let hours = today.getHours() < 10 ? "0" + today.getHours() : today.getHours();
  let minutes =
    today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes();
  let seconds =
    today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
  let date = day + "/" + month + "/" + today.getFullYear();
  let time = hours + ":" + minutes + ":" + seconds;

  let actualDateTime = `${date}|${time}`;
  return actualDateTime;
};

coreFunctions.GetLegoNext = (stage) => {
  console.log(".:coreFunctions.GetLegoNext:.Stage Name", stage);
  switch (stage) {
    case "Validación de identidad":
      return "IdentityValidationComponent";
    // return "LifeTestComponent"
    case "Resumen":
      return "SummaryComponent";
    case "EvidenciasCheckResult":
      return "BioResultsComponent";
    case "Evidencias":
      return "EvidenceComponentHelp";
    case "OcrExtractionResult":
      return "SummaryComponent";
    case "Cuestionario dinamico":
      return "DynamicQuestionary"
    // return "DynamicFormComponent";
    case "EvidenciasValidacion":
      return "BioResultsComponent";
    case "Información de la Solicitud":
      return "InformationalMessageComponent";
    // return "InformationalMessage1Component";
    case "Carga documental":
      return "CargarDocsComponent";
    case "Obtener Dirección":
      return "SummaryComponent";
    case "Oferta de crédito":
      return "OfertaCreditoFormComponent";
    case "Firma de documentos":
      return "DocumentViewerCheckCarrusel"
    // return "DocumentSignComponent";
    // return "FirmaClaveComponent";
    case "Check de aceptación":
      return "PolicyComponent";
    case "PIN de autorización":
      return "OTPComponent";
    case "Seleccion":
      return "SelectOptionsComponents";
    case "Dashboard":
      return "DashboardComponent";
    case "Validación Documental":
      return "DocumentApprovalComponent";
    case "Selección de crédito":
      return "CreditSelectionComponent";
    case "Generación de documentos":
      return "SummaryComponent";
    case "Selección de actores":
      return "GroupActorsComponent";
    // return "CreateGroupComponent";
    case "FirmaEA":
      return "FirmaEA";
    case "Carga Docflow":
      return "SummaryComponent";
    case "GestionCobranza":
      return "FinishColManagementFormComponent";

    case "AutorizaSolicitud":
      return "SummaryComponent";
    case "AsignarSolicitud":
      return "SummaryComponent";
    case "Integración de documentos":
      return "SummaryComponent";
    case "Nom151":
      return "SummaryComponent";
    case "Notificación":
      return "SummaryComponent";
    case "GestionCobranzaHelp":
      return "CollectionManagementComponent";
    case "Encuesta":
      return "SatisfactionSurvey";

    ///INICIO de satge que aun no se han probado si existen
    case "AsignacionMetadatos":
      return "SummaryComponent";

    case "Ejecución paralela":
      return "SummaryComponent";
    case "Finalizar Paralelo":
      return "SummaryComponent";

    case "Carga Docflow Cobranza":
      return "SummaryComponent";
    case "NotificacionAsignacion":
      return "SummaryComponent";
    case "Ratificación Documental":
      return "SummaryComponent";
    case "Search":
      return "DashboardComponent";
    case "Selección de producto":
      return "SelectProductComponent";
    case "StateEvidencia":
      return "SummaryComponent";
    case "FirmaAvanzada":
      return "AdvancedSignViewer";
    case "Cambio de Contraseña":
      return "RecoverPasswordComponentLego";
    ///Fin de satge que aun no se han probado si existen
    default:
      return "SummaryComponent";
  }
};

coreFunctions.DoNextStage = (props) => {
  if (sessionStorage.getItem('token')) {
    //Objeto lleno
    console.log(".................coreFunctions.DoNextStage******: ", props)
    localStorage.setItem('fileId', JSON.stringify(props.State?.folioId))
    props.navigate(`/main/${props.nextComponent}`, { state: props.State })
  }
  else {
    alert("No se encontró usuario.")
  }
}

coreFunctions.GetOcrValue = (array) => {
  let ocr = array.find(e => e.Name == "OcrCapture")
  let type = array.find(e => e.Name == "TypeOcrCapture")
  console.log(".....GetOcrValue...........ocr-----------------: ", ocr, type)
  if (ocr === undefined) {
    return {
      ocr: 0,
      type: 'Online'
    }
  } else {
    return {
      ocr: ocr.Value,
      type: type.Value
    }
  }
}

//new 
coreFunctions.GetNewFieldName = (name) => {
  console.log("Metadato----getNewFieldName-----: ", name.toUpperCase())
  const field = templates?.find(doc => doc.DocumentType === name.toUpperCase());
  console.log("Metadato----getNewFieldName---field--: ", field)
  if (field === undefined || field === null || field == "") {
    console.log("No se encontró Template configurado para el documento: " + name.toUpperCase())
    return null;
  }

  return field.Fields
}

coreFunctions.GetResponsens = (array) => {
  const newArray = array.map((item) => {
    return item.questions
  }).reduce((a, b) => [...a, ...b], []).map((data) => {
    return {
      GroupName: data.GroupName,
      Value: data.Value,
      Name: data.Name
    }
  })

  // console.log("getResponsens--------------------------------------: ", newArray)
  return newArray
}

coreFunctions.GetRedirectStep = (props, navigate) => {
  console.log("props:GetRedirectStep-----------...........", props)
  console.log("props:GetRedirectStep---------------....... ", navigate)

  let documentData = getNameDocINE(null, props.items.Stage)

  let folioId = props.items.Id
  let metadatos = props.items.Metadatos
  let docIds = props.itemsSections.Sections
  let docName = documentData?.Name?.length == 0 ? props.itemNameDoc?.Name : documentData?.Name

  console.log("props:GetRedirectStep-----???????????????????documentData???????---------....... ", documentData)
  let sections = documentData?.Sections?.length > 0 ? documentData?.Sections
    : props.sectionsCurrent
  let status = props.items?.WorkFlow?.WorkflowInstance?.CurrentStatus

  console.log("getRedirectStep:----selfie tranporte setions name.----------status: ", status, docName,
    " , Sections: ", sections)

  let nextComponent = null
  switch (status) {
    case "ValidaciónFacial":
      // console.log("getRedirectStep----props.itemsValidation, props.itemsValidation?.ActiveFacialVerification ***************",props.itemsValidation, props.itemsValidation?.ActiveFacialVerification)
      if (props.itemsValidation != null && props.itemsValidation?.ActiveFacialVerification == "0") {
        nextComponent = 'Carousel'
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, docName, metadatos, docIds } })
      }
      else {
        // nextComponent = 'HelpSelfie'
        // coreFunctions.DoNextStage({ navigate, nextComponent, State: { sections, folioId, docName, metadatos, docIds } })
        const typeProcessSelfie = 2
        nextComponent = 'LifeTestComponent'
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { sections, folioId, docName, metadatos, docIds, typeProcessSelfie } })
      }
      break
    case "DatosOCR":
      let documetId = documentData.DocumentId
      console.log("????????????????????DatosOCR.....................: ", documetId)
      let selfieMeta = null
      nextComponent = 'ExtractionForm'
      coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, sections, docName, documetId, selfieMeta } })
      break
    case "CargaMinucias":
      nextComponent = 'FingerSelectCapture'
      coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
      break
    case "Validación":
      nextComponent = 'ExternalValidations'
      coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
      break
    case "Captura":
      nextComponent = 'IdentityValidationComponent'
      coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
      break
    default:
      // console.log("Entro a paso default")
      return false
  }
}
